const userEndpoints = {
  getMe: { method: "GET", path: "/users/me" },
  updateMe: { method: "PATCH", path: "/users/me" },
  getMyProfilePicture: { method: "GET", path: "/users/me/profile-picture" },
  getUserProfilePicture: (userId) => ({
    method: "GET",
    path: `/users/${userId}/profile-picture`,
  }),
  deleteMyProfilePicture: {
    method: "DELETE",
    path: "/users/me/profile-picture",
  },
  updateMyProfilePicture: {
    method: "PATCH",
    path: "/users/me/profile-picture",
  },
  getUser: (userId) => ({ method: "GET", path: `/users/${userId}` }),
  getUsers: { method: "GET", path: "/users" },
};

export default userEndpoints;
